import type { CashFlowSetting } from 'venn-api';

export const mockUserClassificationCashflowSetting: CashFlowSetting = {
  settingId: '8c8eed6a-75a7-4cce-831f-fbb9bef4a814',
  name: 'User classification setting',
  userCreated: true,
  overrideType: 'CLASSIFICATION',
  updated: 1720176674911,
  created: 1720176674889,
  vintage: 1720176674911,
  assetClass: 'REAL_ESTATE',
  strategyName: 'Real Estate Opportunistic',
  lifeExpectancy: 36,
  growth: 0.018,
  rateOfContribution0: 0.053,
  rateOfContribution4: 0.02,
  rateOfContribution8: 0.09,
  bow: 5.0,
  yield: 0.01,
  assetClassName: 'Real Estate',
};

export const mockUserParameterCashflowSetting: CashFlowSetting = {
  settingId: '8c8eed6a-75a7-4cce-831f-fbb9bef4a814',
  name: 'User parameter setting',
  userCreated: true,
  overrideType: 'PARAMETER',
  updated: 1720176674911,
  created: 1720176674889,
  vintage: 1720176674911,
  assetClass: 'REAL_ESTATE',
  strategyName: 'Real Estate Opportunistic',
  lifeExpectancy: 36,
  growth: 0.018,
  rateOfContribution0: 0.053,
  rateOfContribution4: 0.02,
  rateOfContribution8: 0.09,
  bow: 5.0,
  yield: 0.01,
  assetClassName: 'Real Estate',
};

export const mockSystemDefaultAllWildcardsSetting: CashFlowSetting = {
  settingId: '8c8eed6a-75a7-4cce-831f-fbb9bef4a814',
  name: 'Venn Default Setting',
  userCreated: false,
  overrideType: 'CLASSIFICATION',
  updated: 1720176674911,
  created: 1720176674889,
  vintage: undefined,
  assetClass: undefined,
  strategyName: undefined,
  lifeExpectancy: 42,
  growth: 0.01,
  rateOfContribution0: 0.05,
  rateOfContribution4: 0.03,
  rateOfContribution8: 0.15,
  bow: 4.76,
  yield: 0.02,
  assetClassName: undefined,
};
